/*/
 * Swiper v8 - Promo
/*/
	import Swiper, { Navigation, Pagination } from 'swiper';

	const siteSwiperHome = new Swiper('[site-swiper-products]', {
		modules: [Navigation, Pagination],
		loop: false,
		speed: 1000,
		slidesPerView: 2,
		slidesPerGroup: 2,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			lockClass: 'd-none',
		},
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
			lockClass: 'd-none',
		},
		breakpoints: {
			1600: {
				slidesPerView: 5,
				slidesPerGroup: 5,
			},
			1200: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			},
			768: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			}
		}
	})
